import { Button, Spinner } from 'avo-ui'
import icEdit from 'assets/images/ic-edit.svg'
import icKey from 'assets/images/ic-key.svg'
import { formatDateMoment } from 'utils/utils'
import { FormProfileContainer } from '../../../../containers/user/user-detail/tab-profile/FormProfileContainer'
import { FormAccessibilityContainer } from '../../../../containers/user/user-detail/tab-profile/FormAccessibilityContainer'
import { FormChangePasswordContainer } from '../../../../containers/user/user-detail/tab-profile/FormChangePasswordContainer'
import { useSelector } from 'react-redux'

export const TabProfile = ({ modal, setModal, isLoading }) => {
    const { userDetails } = useSelector((state) => state.userReducer)
    return (
        <div>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'grid grid-cols-2 gap-x-8 px-9 py-4'}>
                        <div className={'flex flex-col w-full border rounded-lg overflow-hidden'}>
                            <div className={'flex items-center px-5 py-2 justify-between border-b bg-blue-5'}>
                                <p className={'text-lg font-bold text-primary-100 capitalize'}>Profile</p>
                                <Button
                                    className={'w-fit'}
                                    title={'EDIT PROFILE'}
                                    icon={icEdit}
                                    onClick={() => setModal({ ...modal, profile: true })}
                                />
                            </div>
                            <div className={'flex flex-col space-y-4 p-5'}>
                                <div className={'flex space-x-5'}>
                                    <p className={'text-neutral-60 w-36'}>Nama</p>
                                    <p className={'text-neutral-90 capitalize'}>{userDetails?.profile?.name}</p>
                                </div>
                                <div className={'flex space-x-5'}>
                                    <p className={'text-neutral-60 w-36'}>Email</p>
                                    <p className={'text-neutral-90'}>{userDetails?.profile?.email}</p>
                                </div>
                                <div className={'flex space-x-5'}>
                                    <p className={'text-neutral-60 w-36'}>Telepon</p>
                                    <p className={'text-neutral-90'}>{userDetails?.profile?.phone_number}</p>
                                </div>
                                <div className={'flex space-x-5'}>
                                    <p className={'text-neutral-60 w-36'}>Tanggal Lahir</p>
                                    <p className={'text-neutral-90'}>
                                        {userDetails?.profile?.birth_date &&
                                            formatDateMoment(userDetails?.profile?.birth_date, 'DD MMMM YYYY')}
                                    </p>
                                </div>
                                <div className={'flex space-x-5'}>
                                    <p className={'text-neutral-60 w-36'}>Jenis Kelamin</p>
                                    <p className={'text-neutral-90 capitalize'}>{userDetails?.profile?.gender}</p>
                                </div>
                            </div>
                        </div>
                        <div className={'flex flex-col space-y-5'}>
                            <div className={'flex flex-col w-full h-fit border rounded-lg overflow-hidden'}>
                                <div className={'flex items-center px-5 py-2 justify-between border-b bg-blue-5'}>
                                    <p className={'text-lg font-bold text-primary-100 capitalize'}>Accessibility</p>
                                    <Button
                                        className={'w-fit'}
                                        title={'EDIT ACCESS'}
                                        icon={icEdit}
                                        onClick={() => setModal({ ...modal, accessibility: true })}
                                    />
                                </div>
                                <div className={'flex flex-col space-y-4 p-5'}>
                                    <div className={'flex space-x-5'}>
                                        <p className={'text-neutral-60 w-36'}>Role</p>
                                        <p className={'text-neutral-90 capitalize'}>
                                            {userDetails?.accessibility?.name}
                                        </p>
                                    </div>
                                    <div className={'flex space-x-5'}>
                                        <p className={'text-neutral-60 w-36'}>Status</p>
                                        <p className={'text-neutral-90 capitalize'}>
                                            {userDetails?.accessibility?.status}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={'flex items-center justify-between px-5 py-6 border rounded-lg'}>
                                <p className={'text-lg font-bold text-primary-100 capitalize'}>Change Password</p>
                                <Button
                                    className={'w-fit'}
                                    title={'UBAH PASSWORD'}
                                    icon={icKey}
                                    onClick={() => setModal({ ...modal, change_password: true })}
                                />
                            </div>
                        </div>
                    </div>
                    {modal?.profile && (
                        <FormProfileContainer
                            show={modal?.profile}
                            onHide={() => setModal({ ...modal, profile: false })}
                        />
                    )}
                    {modal?.accessibility && (
                        <FormAccessibilityContainer
                            show={modal?.accessibility}
                            onHide={() => setModal({ ...modal, accessibility: false })}
                        />
                    )}
                    {modal?.change_password && (
                        <FormChangePasswordContainer
                            show={modal?.change_password}
                            onHide={() => setModal({ ...modal, change_password: false })}
                        />
                    )}
                </>
            )}
        </div>
    )
}
